module.exports = __webpack_public_path__ + "static/lightning-datepicker-error-19d696406c4677faa668aaa96debb936.png";